import { LOGIN_PATH } from 'utils/return-url';
import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Landing spot for URLs that match no route, so a typo lands on a real screen
 * instead of an empty page. The login page is the safe destination for both
 * cases: PublicRoute sends an already authenticated visitor on to their default
 * portal page, and anyone else signs in first.
 */
const NotFoundRedirect = () => <Redirect to={LOGIN_PATH} />;

export default NotFoundRedirect;
